import { useRecoilState, useSetRecoilState } from 'recoil'
import styled from 'styled-components'

import Ticket from '~/features/ticket/components/Ticket'
import TicketInfoAndRefundRule from '~/features/ticket/components/TicketInfoAndRefundRule'
import {
  useShopEventId,
  useTicketTypeList,
} from '~/features/ticket/queries/ticket'
import ticketMobile from '~/shared/assets/background/ticket-info-bg-mobile.png'
import ticketPc from '~/shared/assets/background/ticket-info-bg-pc.png'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import useAuth from '~/shared/hooks/useAuth'
import useViewport from '~/shared/hooks/useViewport'
import { isModalOpenState, ticketDetailParamsState } from '~/shared/states'
import theme from '~/shared/styles/theme'

function TicketPage() {
  const viewport = useViewport()
  const backgroundImage =
    viewport < theme.deviceSizes.medium ? ticketMobile : ticketPc

  const { checkAuth } = useAuth()

  const [isModalOpen, setIsModalOpen] = useRecoilState(isModalOpenState)
  const setTicketDetailParams = useSetRecoilState(ticketDetailParamsState)

  const { data: shopEventId, isLoading: isShopLoading } = useShopEventId()
  const { data, isLoading } = useTicketTypeList(shopEventId!)

  if (isShopLoading || isLoading) return <LoadingScreen />

  const { shop_info, ticket_type_list } = data!

  const isMobile = viewport < theme.deviceSizes.medium

  const handleClickTicket = (eventTicketId: number) => {
    if (!checkAuth()) return

    setTicketDetailParams({
      eventTicketId,
    })
    setIsModalOpen({
      ...isModalOpen,
      contents: 'ticket-detail',
      isOpen: true,
    })
  }

  return (
    <Wrapper>
      <BackgroundImage src={backgroundImage} alt="background image" />
      <Title>티켓 구매</Title>
      <TitleDesc>구매를 원하시는 입장권의 종류를 선택해주세요.</TitleDesc>
      {ticket_type_list.map((ticket) => (
        <Ticket
          key={ticket.id}
          data={ticket}
          isMobile={isMobile}
          onClick={handleClickTicket}
        />
      ))}
      <TicketInfoAndRefundRule data={shop_info} />
    </Wrapper>
  )
}

export default TicketPage

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;

  width: 100vw;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  margin-top: calc(148px + ${theme.size.headerHeight}px);
  margin-bottom: 120px;

  @media ${theme.device.large} {
    gap: 24px;

    /* align-items: start; */
    width: 90vw;
    height: auto;
    margin-top: calc(56px + ${theme.size.headerHeight}px);
  }
`

const BackgroundImage = styled.img`
  position: absolute;
  z-index: ${theme.zIndex.belowBackground};
  top: 0;
  left: 0;

  overflow: hidden;

  width: 100%;
  height: 100%;

  object-fit: cover;

  @media ${theme.device.medium} {
    /* height: auto; */
    background-repeat: repeat;
  }
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Heavy, sans-serif;
  font-size: 42px;
  font-weight: 700;
  line-height: 59px;
  text-align: left;
  white-space: pre-line;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
    font-size: 28px;
    line-height: 40px;
  }
`

const TitleDesc = styled.p`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 33px;

  @media ${theme.device.medium} {
    font-size: 21px;
    line-height: 29px;
  }
`
